export enum EditorState {
  EDIT = 'edit',
  NEW = 'new'
}
